import React, { useState, useEffect } from "react";

import { LocationService } from "services/LocationService";

import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";
import NumberInput from "components/MainApp/atoms/Forms/NumberInput";

import { EventRepository } from 'helpers/EventRepository';

import styles from "./MainApp.atoms.Filters.LocationSelectorModal.module.scss";
import i18n from "i18n";

const LocationSelectorModal = ({ item_id, locations, handleClose }) => {
  // Tiene lo actual y lo del item
  const [_locations, setLocations] = useState([]);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    LocationService.locations_node_by_item(item_id).then((response) => {
      response.map((loc_item) => {
        loc_item.unitsSelected = 0;
        if (locations) {
          let loc_cant = locations.find(
            (l) => l.location_id === loc_item.location_id
          );
          if (loc_cant) {
            loc_item.unitsSelected = loc_cant.unitsSelected;
          }
        }

        return loc_item;
      });
      setLocations(response);
    });
  }, []);

  useEffect(() => {
    validDisabled();
  });

  // useEffect(() => {
  //     setLocations([...locations])
  // }, locations)

  const validDisabled = () => {
    let error = _locations.filter((loc) => loc.error != '' && loc.error != undefined);
    let disabled = true;
    let selected = _locations.filter((loc) => loc.unitsSelected > 0);
    if (selected.length > 0) {
      if (error.length == 0) {
        disabled = false;
      }
    }

    setDisabled(disabled);
  }

  const handleChangeUnitsSelected = (id, value) => {
    if (value) {
      value = parseInt(value);
    }

    if (value < 0) {
      EventRepository.notificationSend({
        label: i18n.t("number.megative.error"),
        type: 'error'
      });
    } else {
      const __locations = [..._locations];
      const locationIndex = __locations.findIndex(
        (loc) => loc.location_id === id
      );

      if (value > __locations[locationIndex].total) {
        let count = value - __locations[locationIndex].total;
        __locations[locationIndex].error = `* ${i18n.t("exceeds.available.quantity", { count: count })}`;
      } else {
        __locations[locationIndex].error = "";
      }
      __locations[locationIndex].unitsSelected = value;

      setLocations(__locations);
      validDisabled();
    }
  };

  const handleAdd = () => {
    if (!disabled) {
      const locationsSelected = _locations.filter((loc) => loc.unitsSelected > 0);
      handleClose && handleClose(locationsSelected);
    }
  };

  const handleErase = () => {
    const locationsSelected = [];
    handleClose && handleClose(locationsSelected);
  };

  return (
    <div className={styles["location-selector-modal-wrapper"]}>
      <div className={styles["location-selector-modal-modal"]}>
        {/* <div className="location-selector-modal-header"></div> */}
        <div className={styles["location-selector-modal-table"]}>
          <div className={styles["location-selector-table-header"]}>
            <h3 className={styles["table-header-title"]}>{i18n.t("locations.type.PLACE")}</h3>
            <h3 className={styles["table-header-title"]}>{i18n.t("quantity")}</h3>
          </div>
          <div className={styles["location-selector-table-rows"]}>
            {_locations?.map((location) => {
              return (
                <div key={location.location_id} className={styles["location-row"]}>
                  <div className={styles["location-row-left"]}>
                    <div>
                      <p className={styles["location-label"]}>
                        {location.location_label}
                      </p>
                      <p className={styles["location-stock"]}>
                        {i18n.t("stock")} {location.total} {i18n.t("units").toUpperCase()}
                      </p>
                    </div>
                  </div>
                  <div className={styles["location-row-right"]}>
                    <NumberInput
                      value={location.unitsSelected}
                      id={location.location_id}
                      handleChange={handleChangeUnitsSelected}
                    />
                    <div className={styles["error"]}>
                      {location.error}
                    </div>

                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles["location-selector-buttons"]}>
          <div className={styles["location-selector-erase-button"]} onClick={handleErase}>
            {i18n.t("delete").toUpperCase()}
          </div>
          <div
            className={`${styles["location-selector-add-button"]} ${disabled ? styles["disabled"] : ""}`}
            onClick={handleAdd}
          >
            {i18n.t("add").toUpperCase()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationSelectorModal;
